import Vue from 'vue'
import Router from 'vue-router'
// 1. 引入路由组件。

import {applyRouteTemplate} from './utils'

Vue.use(Router);

// 2. 定义路由及嵌套规则
const route_template = [
  // { path: '/', component: "login", name:'login' },
  {path: '/', redirect: "/dashboard/homepage"},
  { path: '/login', component: "login", name:'login' },
  {path: '/timeoutPage', component: "timeoutPage"},
  /*
  { path: '/doc', component: "doc" ,
    children: [
      { path: 'caselist', name:'caselist', component: "caselist" },
      { path: 'cases', name:'cases', component: "cases",
        children: [
          { path: 'caseinfo/:id', name:'caseinfo', component: "caseinfo" },
          { path: 'caseDiag/:id', name:'caseDiag', component: "caseDiag" },
          { path: 'evalRecord/:id', name:'evalRecord', component: "evalRecord" },
          { path: 'recordDetail/:id/:aid', name:'recordDetail', component: "recordDetail" },
          { path: 'recordDetail/:id', name:'recordDetail2', component: "recordDetail" },
          { path: 'trainPlan/:id', name:'trainPlan', component: "trainPlan" },
          { path: 'trainRecord/:id', name:'trainRecord', component: "trainRecord" },
          { path: 'collectInfo/:id', name:'collectInfo', component: "collectInfo" },
          { path: 'caseOrder/:id', name:'caseOrder', component: "caseOrder" }
        ]
      },
      {path: 'timeList',name:'timeList', component: "timeList"},
      { path: 'evaluation', name:'evaluation', component: "evaluation" ,
        children:[
          { path: 'evalContent/:id', name:'evalContent', component: "evalContent" }
        ]
      },
      { path: 'startEval', name:'startEval', component: "startEval" },
      { path: 'train', name:'train', component: "train" },
      { path: 'orderList', name:'orderList', component: "orderList" },
      { path: 'orderPay/:id', name:'orderPay', component: "orderPay" },
      { path: 'order', name:'order', component: "order" ,
        children:[
          { path: 'orderInfo/:id', name:'orderInfo', component: "orderInfo" }
        ]
      },
      { path: 'userSet', name:'userSet', component: "userSet" }
    ]
  },
  */
  { path: '/active', component: "activation" },
  { path: '/seelog', component: "seelog", name:'seelog' },
  { path: '/reset', component: "reset" },
  { path: '/trainTime', component: "trainTime", name: "trainTime"},
  { path: '/printwab/:reportid/:uid', component: "printWab" },
  { path: '/print10/:aid/:uid', component: "print10" },
  { path: '/trainTips', component: "trainTips" },
  { path: '/printImg/:imgSrc', component: "printImg" },
  { path: '/dashboard', component: "dashboard" ,
    children: [
      { path: 'homepage', name:'homepage', component: "homepage" }
    ]
  },
  {path: '/errorPage', component: "errorPage"},
  {path: '/noPage', component: "noPage"},
  {path: "*", redirect: "/"},
];

const routes = JSON.parse(JSON.stringify(route_template));
applyRouteTemplate(routes);


/*
const router = new Router({
  linkActiveClass: 'u-link--Active',
  routes
});
export default router;
*/
export default new Router({
  linkActiveClass: 'u-link--Active',
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js